import { Alert, Button, FormControl, FormLabel, MenuItem, Select, Stack } from '@mui/material';
import { BackLink } from '@/global/components/BackLink';

interface Props {
    returnFirstStep: () => void,
    handlePickVariant: () => void,
    handleChangeVariant: (value: 'online' | 'offline') => void,
    value: 'online' | 'offline'
}

export function VariantPickStep({returnFirstStep, handleChangeVariant, value, handlePickVariant}: Props) {
    return (
        <Stack
            width={{lg: '60%', xs: '100%'}}
            flexDirection={'column'}
            gap={2}
            sx={{
                margin: '0 auto',
                p: 4,
                borderRadius: '26px',
                background: '#F5F5F5',
                gap: '16px'
            }}
        >
            <BackLink
                label={'Вернуться к вводу ИИН'}
                onClick={returnFirstStep}
                sx={{
                    alignSelf: 'flex-start'
                }}
            />
            <FormControl fullWidth>
                <FormLabel
                    sx={{
                        mb: 2
                    }}
                >
                    Способ сдачи
                </FormLabel>
                <Select
                    value={value}
                    onChange={(e) => handleChangeVariant(e.target.value as 'online' | 'offline')}
                    displayEmpty
                >
                    <MenuItem
                        value='online'
                    >
                        Онлайн
                    </MenuItem>
                    <MenuItem
                        value='offline'
                    >
                        В автошколе
                    </MenuItem>
                </Select>
            </FormControl>
            {
                value === 'online' && (
                    <Alert
                        severity={'info'}
                    >
                       Стоимость Онлайн сдачи – 2480 тенге
                    </Alert>
                )}
            {
                value === 'offline' && (
                    <Alert
                        severity={'info'}
                    >
                        Стоимость сдачи в автошколе – бесплатная 1 попытка в месяц. Досрочная попытка – 2480 тенге
                    </Alert>
                )}
            <Button
                onClick={handlePickVariant}
            >
                Далее
            </Button>
        </Stack>
    );
}